import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useSite } from '../lib/SiteContentContext';

export default function FAQ() {
  const { faqs } = useSite();
  return (
    <section className="py-14 md:py-20 container" aria-labelledby="faq-heading">
      <div className="grid lg:grid-cols-2 gap-10 lg:gap-14">
        <div>
          <div className="text-brand-coral text-sm font-semibold uppercase tracking-widest">Frequently asked</div>
          <h2 id="faq-heading" className="mt-2 font-display text-3xl sm:text-4xl md:text-5xl text-brand-ink">
            Everything you need to <span className="italic text-brand-teal">know</span>.
          </h2>
          <p className="mt-3 text-brand-ink/70 text-base md:text-lg max-w-md">
            Can’t find your answer?{' '}
            <a
              href="/contact"
              className="underline decoration-brand-sun decoration-4 underline-offset-4 hover:text-brand-teal"
            >
              Get in touch
            </a>{' '}
            - we usually reply the same day.
          </p>
        </div>
        <div>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-ink/10">
                <AccordionTrigger className="text-left font-display text-lg md:text-xl text-brand-ink hover:no-underline hover:text-brand-teal py-5 md:py-6 focus-visible:outline-none focus-visible:text-brand-teal">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-ink/70 text-base pb-6 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
